// const AWS = require('aws-sdk')
// const { S3Client, PutObjectCommand } = require('@aws-sdk/client-s3')
// const { getSignedUrl } = require('@aws-sdk/s3-request-presigner')

const { S3Client, GetObjectCommand } = require('@aws-sdk/client-s3')
const { Upload } = require('@aws-sdk/lib-storage')
const { CloudFrontClient, CreateInvalidationCommand } = require('@aws-sdk/client-cloudfront')

// 서비스 정보 로드
export async function getServiceInfo(app) {
  // console.log('getServiceInfo')
  return await app.$axios.post('/v1/service/info')
}
// 약관 정보 로드
export async function getAgreement(app, type = '') {
  // console.log('getAgreement')
  return await app.$axios.post('/v1/service/agreement', { type })
}
// 회원가입
export async function setSignUp(app, userFullName, userDisplayName, deviceToken, userStatus, userEmail) {
  return await app.$axios.post('/v1/user/signup', {
    userFullName,
    userDisplayName,
    deviceToken,
    userStatus,
    userEmail,
  })
}
// 로그인
export async function setSignIn(app, deviceToken, isLinkWithSignin) {
  // console.log('setSignIn')
  return await app.$axios.post('/v1/user/signin', { deviceToken, isLinkWithSignin })
}

// 회원가입 Email 인증코드 전송
export async function setVerifyCode(app, userEmail, verifyType, isGuest) {
  // console.log('setVerifyCode')
  return await app.$axios.post('/v1/user/verify', { userEmail, verifyType, isGuest })
}

// 회원가입 Email 인증코드 확인
export async function checkVerify(app, userEmail, verifyType, verifyCode) {
  // console.log('checkVerify')
  return await app.$axios.post('/v1/user/check-verify', { userEmail, verifyType, verifyCode })
}

// SignIn 통합 후 Email 인증코드 확인 및 firebase 정보 업데이트
export async function checkVerifyWithFirebase(app, userId, userEmail, verifyType, verifyCode, version) {
  // console.log('checkVerify')
  return await app.$axios.post('/v1/user/check-verify-firebase', { userId, userEmail, verifyType, verifyCode, version })
}

// user session 만료 시 token 호출
export async function getUserToken(app, userId) {
  return await app.$axios.post('/v1/user/token', { userId })
}

// 워크스페이스 도메인 조회
export async function chkWsDomain(app, wsDomain) {
  // console.log('chkWsDomain')
  return await app.$axios.post('/v1/ws/domain', { wsDomain })
}
// 워크스페이스 생성
export async function setCreateWs(app, wsName, wsDomain, wsTeamType) {
  // console.log('setCreateWs')
  return await app.$axios.post('/v1/ws/create', {
    wsName,
    wsDomain,
    wsTeamType,
  })
}

// 워크스페이스 초대
export async function setInviteWs(app, wsId, invitorName, userEmail) {
  // console.log('setInviteWs')
  return await app.$axios.post('/v1/ws/invite', { wsId, invitorName, userEmail })
}

// export async function getUserInfo(app, userId) {
//   console.log('getUserInfo')
//   return await app.$axios.post('/v1/')
// }

// 워크스페이스 참여 요청
export async function setRequestJoinWs(app, wsId, userName) {
  // console.log('setRequestJoinWs')
  return await app.$axios.post('/v1/ws/request', { wsId, userName })
}
// 회원정보 수정
export async function setUserUpdate(app, userFullName, userDisplayName) {
  // console.log('setUserUpdate')
  return await app.$axios.post('/v1/user/update', { userFullName, userDisplayName })
}

// 회원 Funnel Update
export async function setUserFunnel(app, funnel) {
  // console.log('setUserFunnel')
  return await app.$axios.post('/v1/user/update', { funnel })
}
// 워크스페이스 수정
export async function setWsUpdate(app, wsId, { wsName, wsDomain, wsMagicLinkEnabled, wsMagicLinkUrl }) {
  // console.log('setWsUpdate')
  return await app.$axios.post('/v1/ws/update', {
    wsId,
    wsName,
    wsDomain,
    wsMagicLinkEnabled,
    wsMagicLinkUrl,
  })
}

// 워크스페이스 로고 삭제
export async function deleteWsLogo(app, wsId) {
  // console.log('deleteWsLogo')
  return await app.$axios.post('/v1/ws/delete-logo', {
    wsId,
  })
}
export async function deleteUserPicture(app) {
  // console.log('deleteUserPicture')
  return await app.$axios.post('/v1/user/delete-user-picture', {})
}
// 워크스페이스 삭제
export async function deleteWs(app, type, wsId, wsDomain) {
  return await app.$axios.post('/v1/ws/delete', { type, wsId, wsDomain })
}

export async function setWsLeave(app, wsId, userId) {
  return await app.$axios.post('/v1/ws/leave', {
    wsId,
    userId,
  })
}

// 참여 워크스페이스 조회
export async function getUserWsList(app) {
  // console.log('getUserWsList')
  return await app.$axios.post('/v1/user/ws')
}

//워크스페이스 멤버 목록
export async function getWsMember(app, wsId) {
  return await app.$axios.post('/v1/ws/member/list', { wsId })
}

//워크스페이스 멤버 목록
export async function setWsMemberType(app, wsId, userId, memberType) {
  return await app.$axios.post('/v1/ws/member/manager', {
    wsId,
    userId,
    memberType,
  })
}

// 이메일을 통해 접속 시 워크스페이스 멤버 추가
export async function setPublicAccept(app, wsId, userId) {
  return await app.$axios.post('/v1/ws/public-accept', { wsId, userId })
}

export async function getInvited(app, inviteeEmail) {
  return await app.$axios.post('/v1/ws/invited', { inviteeEmail })
}

export async function getUpdateMtCnt(app, wsId) {
  return await app.$axios.post('/v1/ws/updated-meeting-cnt', { wsId })
}

export async function respondInvitation(app, wsId, userId, inviteId, refuse) {
  return await app.$axios.post('/v1/ws/respond-invitation', {
    wsId,
    userId,
    inviteId,
    refuse,
  })
}

/**
 * user Setting 정보 조회
 * @param {*} app context
 * @param {*} wsId workspace Id
 */
export async function getUserSetting(app, wsId) {
  return await app.$axios.post('/v1/user/getsetting', {
    wsId,
  })
}

/**
 * user Setting 업데이트
 * @param {*} app context
 * @param {*} wsId workspace Id
 * @param {*} emailNotiType email 설정 값 - always: 모든 메일, metioned: 멘션된 메일만, never: 받지 않음
 * @returns
 */
export async function updateUserSetting(app, wsId, emailNotiType) {
  return await app.$axios.post('/v1/user/setting', {
    wsId,
    emailNotiType,
  })
}

// 파일 업로드
export async function setFileUpload(app, convertedFile, type, pathId, id, fileIndex) {
  // console.log('setFileUpload')

  let convertedFileType = typeof convertedFile
  let mimeType
  let file

  const fileNumber = fileIndex ? `_${fileIndex}` : ''

  // base64 string
  if (convertedFileType === 'string') {
    mimeType = convertedFile.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0]

    file = await fetch(convertedFile)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], `${id}.${mimeType.split('/').pop()}`, { type: mimeType }))
  }
  // blob object
  else if (convertedFileType === 'object') {
    mimeType = convertedFile.type
    file = new File([convertedFile], `${id}${fileNumber}.${mimeType.split('/').pop()}`, {
      lastModified: new Date().getTime(),
      type: convertedFile.type,
    })
  }

  const s3Client = new S3Client({
    credentials: {
      accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
    },
    region: process.env.VUE_APP_AWS_S3_REGION,
    // endpoint: process.env.VUE_APP_AWS_S3_ENDPOINT,
  })
  let contentType = `${mimeType.split('/').pop()}`
  const params = {
    Bucket: process.env.VUE_APP_AWS_S3_BUCKET,
    Key:
      id !== undefined
        ? `${type}/${pathId ? pathId : ''}/${id}${fileNumber}.${contentType}`
        : `${type}/${pathId}${fileNumber}.${contentType}`,
    Body: file,
    ContentType: mimeType,
  }
  const parallellUploads = new Upload({
    client: s3Client,
    partSize: 5 * 1024 * 1024, // default 5MB
    params: params,
    leavePartsOnError: true,
  })

  return parallellUploads

  // return await app.$axios.put(`/v1/upload/${type}/${id}.${mimeType.split('/').pop()}`, file, {
  //   headers: {
  //     'Content-Type': mimeType,
  //   },
  // })
}

/**
 * 업로드 후 s3 에 정상적으로 업로드가 되었는지 확인하는 로직
 * @param {*} app
 * @param {*} key
 * @returns boolean
 */
export async function chkUploadedFile(app, key) {
  return await app.$axios.post('/v1/upload/chk-uploaded', {
    key,
  })
}

/**
 * S3 에서 파일을 다운로드 한다.
 * @param {*} app
 * @param {*} wsId
 * @param {*} clipId
 * @returns
 */
export async function getFileDownload(app, wsId, clipId) {
  let response
  let progressData = 0
  // 진행상황 로컬스토리지에 저장
  let downloadProgress = setInterval(function () {
    if (progressData && s3Result.ContentLength) {
      localStorage.setItem('downloadProgress', progressData)
      localStorage.setItem('downloadFileSize', s3Result.ContentLength)
      localStorage.setItem('downloadPercent', (progressData / s3Result.ContentLength) * 100)
    }
  }, 100)
  const streamToString = (stream) => {
    return new Promise((resolve, reject) => {
      if (stream instanceof ReadableStream === false) {
        reject('Expected stream to be instance of ReadableStream, but got ' + typeof stream)
      }
      let chunks = []
      const reader = stream.getReader()
      const processRead = ({ done, value }) => {
        if (done) {
          // resolve promise with chunks
          resolve(chunks)
          return
        }
        if (parseInt(value.byteLength)) progressData += parseInt(value.byteLength)
        chunks.push(value)
        // Not done, keep reading
        reader.read().then(processRead)
      }
      // start read
      reader.read().then(processRead)
    })
  }

  let bucket
  // Clip Directory 적용 후 Key
  let key
  // Clip Directory 적용 전 Key
  let legacyKey

  // Welcom 영상일 경우
  // if (isCopied !== undefined && isCopied !== null && isCopied) {
  //   bucket = process.env.VUE_APP_AWS_S3_BUCKET_PUBLIC
  //   key = `demo/topic_based_template_explain.mp4`
  //   legacyKey = `demo/topic_based_template_explain.mp4`
  // } else {
  bucket = process.env.VUE_APP_AWS_S3_BUCKET
  key = `clip/${wsId}/${clipId}.mp4`
  legacyKey = `clip/${clipId}.mp4`
  // }
  const s3Client = new S3Client({
    credentials: {
      accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
    },
    region: process.env.VUE_APP_AWS_S3_REGION,
    // endpoint: process.env.VUE_APP_AWS_S3_ENDPOINT,
  })
  let s3Result
  try {
    s3Result = await s3Client.send(
      new GetObjectCommand({
        Bucket: bucket,
        Key: key,
      })
    )
  } catch (e) {
    // WS Directory 구조에서 못찾았으면
    try {
      // Clip Id Key 파일 확인
      s3Result = await s3Client.send(
        new GetObjectCommand({
          Bucket: bucket,
          Key: legacyKey,
        })
      )
    } catch (k) {
      console.log()
    }
  } finally {
    if (
      s3Result !== undefined &&
      s3Result !== null &&
      s3Result.ContentType !== undefined &&
      s3Result.ContentType.includes('mp4')
    ) {
      let data = await streamToString(s3Result.Body)
      let blob = new Blob(data, { type: s3Result.ContentType })
      clearInterval(downloadProgress)
      response = blob
    }
  }
  return response
}

// Invalid Cache (파일 업데이트 후 cloudfront 캐시 무효화)
export async function setInvalidCache(app, key) {
  var params = {
    DistributionId: process.env.VUE_APP_AWS_CLOUD_FRONT_DISTRIBUTION_ID /* required */,
    InvalidationBatch: {
      /* required */ CallerReference: `${new Date().getTime()}` /* required */,
      Paths: {
        /* required */ Quantity: 1 /* required */,
        Items: [
          key,
          /* more items */
        ],
      },
    },
  }

  const client = new CloudFrontClient({
    credentials: {
      accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
    },
    region: process.env.VUE_APP_AWS_S3_REGION,
    // endpoint: process.env.VUE_APP_AWS_S3_ENDPOINT,
  })
  const command = new CreateInvalidationCommand(params)
  const response = await client.send(command)
  return response
}

// 공유 URL 생성 // TODO: fallbackUrl은 나중에 추가
export async function getShareUrl(app, title, content, imgUrl, linkUrl) {
  // console.log('getShareUrl')

  const params = {
    dynamicLinkInfo: {
      domainUriPrefix: 'tapeapp.page.link',
      link: linkUrl,
      androidInfo: {
        // androidPackageName: "com.",
        // androidFallbackLink: fallbackUrl
      },
      iosInfo: {
        // iosBundleId: 'com.',
        // iosFallbackLink: fallbackUrl
      },
      // analyticsInfo: {
      //   googlePlayAnalytics: {
      //     utmSource: "share",
      //     utmMedium: USER_ID ? USER_ID : "",
      //     utmCampaign: TL_CD ? TL_CD : "",
      //     utmContent: LG_CD ? LG_CD : ""
      //   }
      // },
      socialMetaTagInfo: {
        socialTitle: title,
        socialDescription: content,
        socialImageLink: imgUrl,
      },
    },
    suffix: {
      option: 'UNGUESSABLE',
    },
  }

  return await app.$axios.post(
    'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=' + process.env.VUE_APP_FB_API_KEY,
    params,
    {
      transformRequest: [
        (data, headers) => {
          delete headers.common['Authorization']
          delete headers.common['X-Api-Key']
          return data
        },
        ...app.$axios.defaults.transformRequest,
      ],
    }
  )
}

// 초대 URL 생성 // TODO: fallbackUrl은 나중에 추가
export async function getInviteUrl(app, title, content, imgUrl, linkUrl) {
  // console.log('getInviteUrl')

  const params = {
    dynamicLinkInfo: {
      domainUriPrefix: 'tapeinvite.page.link',
      link: linkUrl,
      androidInfo: {
        // androidPackageName: "com.",
        // androidFallbackLink: fallbackUrl
      },
      iosInfo: {
        // iosBundleId: 'com.',
        // iosFallbackLink: fallbackUrl
      },
      // analyticsInfo: {
      //   googlePlayAnalytics: {
      //     utmSource: "share",
      //     utmMedium: USER_ID ? USER_ID : "",
      //     utmCampaign: TL_CD ? TL_CD : "",
      //     utmContent: LG_CD ? LG_CD : ""
      //   }
      // },
      socialMetaTagInfo: {
        socialTitle: title,
        socialDescription: content,
        socialImageLink: imgUrl,
      },
    },
    suffix: {
      option: 'UNGUESSABLE',
    },
  }

  return await app.$axios.post(
    'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=' + process.env.VUE_APP_FB_API_KEY,
    params,
    {
      transformRequest: [
        (data, headers) => {
          delete headers.common['Authorization']
          delete headers.common['X-Api-Key']
          return data
        },
        ...app.$axios.defaults.transformRequest,
      ],
    }
  )
}

// 매직 링크 설정
export async function setMagicLink(app, wsId) {
  return await app.$axios.post('/v1/ws/link', {
    wsId,
  })
}

// 매직 링크 조회
export async function chkMagicLink(app, wsId, magicLinkCode) {
  return await app.$axios.post('/v1/ws/code', { wsId, magicLinkCode })
}

// 워크스페이스 가입 정보 조회
export async function getWsAccept(app, wsId, userId) {
  return await app.$axios.post('/v1/ws/accept-info', { wsId, userId })
}

// 워크스페이스 가입 처리
export async function setWsAccept(app, wsId, magicLinkCode, userId) {
  return await app.$axios.post('/v1/ws/accept', { wsId, magicLinkCode, userId })
}

// 워크스페이스 용량 확인
export async function getWsUsedStorage(app, wsId, wsDomain) {
  return await app.$axios.post('/v1/ws/used-storage', { wsId, wsDomain })
}
/**
 * 로그인한 유저의 워크스페이스에 올린 clip count 를 가져온다.
 * @param {*} app
 * @param {*} wsDomain 워크스페이스 도메인
 * @param {*} userId 유저아이디
 * @returns
 */
export async function getWsClipCnt(app, wsDomain, userId) {
  return await app.$axios.post('/v1/ws/clip-count', { wsDomain, userId })
}

// 슬랙 연동
export async function sendSlackMessage(app, wsId, chId) {
  return await app.$axios.post('/v1/slack/send-message', { wsId, chId })
}

//슬랙 연동해제
export async function disconnectSlackIntegration(app, wsId, chId) {
  return await app.$axios.post('/v1/slack/disconnect', { wsId, chId })
}
